module.exports = __webpack_public_path__ + "img/emotional-aggression.37836870.svg";